import { ROUTES } from 'configs/routes/constants';
import Settings from 'configs/Settings';

const redirectToExternalLogin = (location = {}) => {
  const externalPath = '/';

  if (!Settings.isLocal && location.pathname === ROUTES.LOGIN) {
    window.location.replace(externalPath);
  }
};

const isRenderInIframe = () => {
  return window.parent.location !== window.location;
};

const locationsAreEqual = (firstLocation, secondLocation) => {
  return (
    firstLocation.pathname === secondLocation.pathname &&
    firstLocation.search === secondLocation.search &&
    firstLocation.hash === secondLocation.hash
  );
};

export { redirectToExternalLogin, isRenderInIframe, locationsAreEqual };
